<p>sed-events-table works!</p>
